import React, { Component } from "react";
import MixpanelService from "../utils/MixpanelService";
import MenuButton from "./MenuButton";

const Menu = ({
  dashboardPath,
  pharmacySubmissionPath,
  pharmacyEncounterSubmissionPath,
  medicalSubmissionPath,
  medicalEncounterSubmissionPath,
  entityProfilePath,
  submissionBalancePath,
  purchaseValidationPath,
  reportsPath,
}) => {
  const curPath = window.location.pathname;

  return (
    <div className="menu__container">
      <MenuButton
        url={dashboardPath}
        icon={<span className="material-symbols-rounded">grid_view</span>}
        title="Home"
        isActiveHandler={() => curPath.includes("dashboard")}
      />
      <MenuButton
        icon={<span className="material-symbols-rounded">file_present</span>}
        title="Claims Data"
        mixpanelSource="esp_nav_bar_claims_data_button"
        dropdownOptions={[
          {
            name: "Pharmacy Submissions",
            url: pharmacySubmissionPath,
            mixpanelEventName: "esp_nav_bar_pharmacy_submissions_clicked",
            mixpanelSource: "esp_nav_bar_pharmacy_submissions_option",
          },
          {
            name: "Pharmacy Encounter Submissions",
            url: pharmacyEncounterSubmissionPath,
            mixpanelEventName: "esp_nav_bar_encounter_submissions_clicked",
          },
          {
            name: "Medical Submissions",
            url: medicalSubmissionPath,
            mixpanelEventName: "esp_nav_bar_medical_submissions_clicked",
          },
          {
            name: "Medical Encounter Submissions",
            url: medicalEncounterSubmissionPath,
            mixpanelEventName: "esp_nav_bar_medical_encounter_submissions_clicked",
          },
        ]}
      />
      <MenuButton
        icon={<span className="material-symbols-rounded">contacts</span>}
        title="Entity Profile"
        dropdownOptions={[{ name: "Covered Entities", url: entityProfilePath }]}
      />
      <MenuButton
        defaultUrl={entityProfilePath}
        icon={<span className="material-symbols-rounded">contract</span>}
        title="Account Integrity"
        dropdownOptions={[
          { name: "Submission Balances", url: submissionBalancePath },
          {
            name: "Purchase Validation",
            url: purchaseValidationPath,
            mixpanelEventName: "esp_horizon_purchval_nav",
          },
        ]}
        isActiveHandler={() =>
          ["purchase_validation", "identifier_mapping", "submission_balances"].some((route) =>
            curPath.includes(route)
          )
        }
      />
      <MenuButton
        defaultUrl={entityProfilePath}
        icon={<span className="material-symbols-rounded">leaderboard</span>}
        title="Reports"
        dropdownOptions={[
          {
            name: "Reports Library",
            url: reportsPath,
            mixpanelEventName: "esp_nav_bar_view_reports_clicked",
          },
        ]}
        isActiveHandler={() => curPath.includes("reports")}
      />
    </div>
  );
};

export default Menu;
